import { appIntl } from '@crema/utility/helper/Utils';
import {
    FETCH_ERROR,
    FETCH_SUCCESS,
    FETCH_START,
    GET_LIST_NOTULENSI,
    GET_SHARED_NOTULENSI,
    SHOW_MESSAGE,
    GET_DETAIL_DOC_NOTULENSI
} from 'shared/constants/ActionTypes';
import { getListDocNotulensi, getDocSharedWithMeNotulensi, addDocNotulensi, editDocNotulensi, getDetailDocNotulensi } from '@crema/services/apis/notulensi';

export const onGetListNotulensi = (page = 0, filter, general = '') => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getListDocNotulensi(page, filter, general)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: GET_LIST_NOTULENSI, payload: data })
                    dispatch({ type: FETCH_SUCCESS })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
};

export const onGetSharedDocNotulensi = (page = 0) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getDocSharedWithMeNotulensi(page)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: GET_SHARED_NOTULENSI, payload: data })
                    dispatch({ type: FETCH_SUCCESS })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: 'Gagal mendapatkan data',
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
}

export const onAddDocNotulensi = (data, handleNavigate) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        addDocNotulensi(data)
            .then((res) => {
                if (res.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Berhasi menambahkan data notulensi' })
                    setTimeout(() => {
                        handleNavigate()
                    }, 1500)
                } else {
                    console.error(res)
                    dispatch({ type: FETCH_ERROR, payload: 'Gagal menambahkan data' })
                }
            })
            .catch((error) => {
                console.error(error)
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
}


export const onEditDocNotulensi = (id, data, handleNavigate) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        editDocNotulensi(id, data)
            .then((res) => {
                if (res.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Berhasi mengedit data notulensi' })
                    setTimeout(() => {
                        handleNavigate()
                    }, 1500)
                } else {
                    console.error(res)
                    dispatch({ type: FETCH_ERROR, payload: 'Gagal mengedit data' })
                }
            })
            .catch((error) => {
                console.error(error)
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
}

export const onGetDetailDocNotulensi = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getDetailDocNotulensi(id)
            .then((res) => {
                if (res.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_DETAIL_DOC_NOTULENSI, payload: res })
                } else {
                    console.error(res)
                    dispatch({ type: FETCH_ERROR, payload: 'Gagal mendapatkan data detail' })
                }
            })
            .catch((error) => {
                console.error(error)
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
}

export const onDeleteDocNotulensi = (id, handleNavigate) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        deleteDocNotulensi(id)
            .then((res) => {
                if (res.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Berhasi menghapus dokumen notulensi' })
                    setTimeout(() => {
                        handleNavigate()
                    }, 1500)
                } else {
                    console.error(res)
                    dispatch({ type: FETCH_ERROR, payload: 'Gagal menghapus dokumen notulensi' })
                }
            })
            .catch((error) => {
                console.error(error)
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
}
